<template>
  <CRow>
    <CCol col="12" md="12">
      <CCard style="top: 10px">
        <CCardHeader>
          <p>
            <DatePicker
              v-model="value1"
              type="date"
              range
              placeholder="Select date range"
              style="float: left"
            ></DatePicker>

            <CButton
              block
              color="success"
              style="float: right; width: 120px"
              @click="wizard()"
            >
              <i class="fa fa-plus" aria-hidden="true"></i> Add new</CButton
            >
          </p>
        </CCardHeader>

        <CCardBody>
          <CDataTable
            :items="tableData"
            :fields="fields"
            pagination
            clickable-rows
            hover
          >
            <template #image="{ item }">
              <td>
                <img :src="item.image" style="width: 50px; height: 50px" />
              </td>
            </template>
            <template #status="{ item }">
              <td>
                <span v-if="item.status == true">
                  <a
                    href="#"
                    rel="noreferrer noopener"
                    target="_blank"
                    class="badge badge-success ml-1"
                  >
                    Active
                  </a></span
                >
                <span v-else>
                  <a
                    href="#"
                    rel="noreferrer noopener"
                    target="_blank"
                    class="badge badge-danger ml-1"
                  >
                    InActive
                  </a>
                </span>
              </td>
            </template>
            <template #Action="{ item, index }">
              <td>
                <CButton
                  color="primary"
                  variant="outline"
                  square
                  size="sm"
                  style="width: 54px"
                  @click="editToken(item, index)"
                >
                  Edit </CButton
                ><br /><br />
                <!-- <CButton
                  color="danger"
                  variant="outline"
                  square
                  size="sm"
                  @click="deleteRoute(item, index)"
                >
                  Delete
                </CButton> -->
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from "../tables/Table";
import { APIService } from "../../apiservice.js";
import Swal from "sweetalert2";
import AppVue from "../../App.vue";
import firebase from "firebase";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
const db = firebase.firestore();
export default {
  components: { CTableWrapper, DatePicker },
  data() {
    return {
      value1: [],
      fields: [
        {
          label: "Image",
          key: "image",
          sortable: true,
        },
        {
          label: "Date",
          key: "Date",
          sortable: true,
        },
        {
          label: "StartDate",
          key: "StartDate",
          sortable: true,
        },
        {
          label: "Title",
          key: "quizTitle",
          sortable: true,
        },
        {
          label: "Status",
          key: "status",
          sortable: true,
        },

        // {
        //    label: "field4",
        //   key: "field4",
        //   sortable: true,
        // },
        {
          key: "Action",
          sortable: true,
        },
      ],
      speciesCode: null,
      speciesName: "",
      documentId: "",
      tableData: [],
      editSpecies: [],
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false,
      image1: false,
    };
  },
  watch: {
    value1() {
      // let v1 = moment(this.value1[0]).format("DD-MMM-YYYY");
      // let v2 = moment(this.value1[1]).format("DD-MMM-YYYY");

      var res = new Date(this.value1[1]);
      res.setDate(res.getDate() + 1);

      let v1 = firebase.firestore.Timestamp.fromDate(new Date(this.value1[0]));
      let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));
      // this.tableData2 = [];
      db.collection("quiz")
        .where("scramble", "==", true)
        .where("quizdate", ">=", v1)
        .where("quizdate", "<=", v2)
        .orderBy("quizdate", "desc")
        .get()
        .then((snapshot) => {
          this.tableData = [];
          snapshot.forEach((doc) => {
            this.tableData.push(this.assignsmallData(doc));
          });

          this.loading = false;
        });
    },
  },
  methods: {
    wizard() {
      this.$router.push({ name: "quiz" });
    },
    editToken(item, index) {
      this.$router.push({
        name: "editQuiz",
        params: { id: item.id, data: "scramble" },
      });
    },
    assignsmallData(doc) {
      let smallDocument = {
        id: doc.id,
        quizTitle: doc.data().quizTitle,
        question: doc.data().question,
        options: doc.data().options,
        answer: doc.data().answer,
        status: doc.data().status,
        image: doc.data().image,
        quiztype: doc.data().quiztype,
        starttime: doc.data().starttime,
        endtime: doc.data().endtime,
        scramble: doc.data().scramble,
        dfs: doc.data().dfs,
        Date: moment(doc.data().quizdate.seconds * 1000).format(
          "DD-MMM-YYYY , hh:mm:ss:a"
        ),
        StartDate: moment(doc.data().starttime.seconds * 1000).format(
          "DD-MMM-YYYY , hh:mm:ss:a"
        ),
      };
      return smallDocument;
    },
    gettokens() {
      this.tableData = [];
      const db = firebase.firestore();

      // var startOfToday = new Date();
      // startOfToday.setHours(0, 0, 0, 0);
      // var endOfToday = new Date();
      // endOfToday.setHours(23, 59, 59, 999);

      var res = new Date();
      res.setDate(res.getDate() + 3);

      let v1 = firebase.firestore.Timestamp.fromDate(new Date());
      let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));

      db.collection("quiz")
        .where("scramble", "==", true)
        .where("quizdate", ">=", v2)
        .where("quizdate", "<=", v1)
        .orderBy("quizdate", "desc")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.tableData.push(this.assignsmallData(doc));
          });

          this.loading = false;
        });
    },
    rowClicked(item, index, column, e) {
      this.documentId = item.id;
    },

    deleteRoute(item) {
      this.documentId = item.id;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          width: "600px",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.deletecompanyDetails();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    deletecompanyDetails(item) {
      db.collection("companyDetails2")
        .doc(this.documentId)
        .delete()
        .then(() => {
          this.gettokens();
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
    },
  },
  created() {
    this.gettokens();
  },
};
</script>
<style>
.swal2-cancel {
  margin: 10px !important;
}
</style>
<style>
.swal2-cancel {
  margin: 10px !important;
}
.sk-wave-rect {
  background-color: #4638c2;
  height: 100%;
  width: 15%;
  -webkit-animation: sk-wave 1.2s ease-in-out infinite;
  animation: sk-wave 1.2s ease-in-out infinite;
}
</style>
